module.exports = __webpack_public_path__ + "stylesheets/footer_ffcee2ad96e04621dfb5f8504fae973e.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/footer.less
// module id = fAML
// module chunks = 118